import React from 'react';
import PropTypes from 'prop-types';

import {ControllerContainer} from '@stubhub/react-store-provider';

import controllerFactory from './controller';

import ChildSEOLinks from './';

const ChildSEOLinksContainer = (props) => {
  const {namespace} = props;

  return <ControllerContainer namespace={namespace} factory={controllerFactory} component={ChildSEOLinks} {...props} />;
};

ChildSEOLinksContainer.propTypes = {
  namespace: PropTypes.string,
};

export default ChildSEOLinksContainer;
